import { setRangeMax } from './helpers';

export const setFloorsMax = setRangeMax('floorn');
